import { colors } from "constants/colors";
import { createUseStyles } from "react-jss";

const styles = createUseStyles(theme => ({
  toggle: {
    display:"flex",
    alignItems:"center",
    "& span":{
      marginLeft:"8px",
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "20px",
      color: theme.toggle.color
    },
    "& .react-toggle--checked": {
        "& .react-toggle-thumb": {
            left: "22px",
        },
        "& .react-toggle-track": {
            backgroundColor: theme.toggle.checked.backgroundColor,
            "&:hover": {    
                backgroundColor: theme.toggle.checked.hover.backgroundColor
            }
        }
    },
    "& .react-toggle": {
        "& .react-toggle-track": {
            width: "44px",
            height: "24px",
            backgroundColor: theme.toggle.unchecked.backgroundColor,
            "&:hover": {
                backgroundColor: theme.toggle.unchecked.hover.backgroundColor
            }
        },
    },
    "& .react-toggle-thumb": {
        backgroundColor: theme.toggle.thumbColor,
        left: "2px",
        width: "20px",
        height: "20px",
        top: "2px",
        border: "none",
        boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.06), 0px 1px 3px 0px rgba(16, 24, 40, 0.1)",
        filter: "drop-shadow(0px 1px 2px rgba(16, 24, 40, 0.06)) drop-shadow(0px 1px 3px rgba(16, 24, 40, 0.10))"
    },
     "& .react-toggle--focus": {
        "& .react-toggle-thumb": {
            boxShadow: `0px 0px 2px 3px ${colors.primary600Blue} !important`
        },
    },
  }
}));

export default styles;
